import { Component, Inject, OnInit } from '@angular/core';
import { Sort, SortDirection } from '@angular/material/sort';
import { Router } from '@angular/router';
import { Contract } from '../../../classes';
import { CONTRACTS_PROVIDER_SERVICE, IContractsProviderService } from '../../../interfaces';

@Component({
  selector: 'app-contract-table',
  templateUrl: './contract-table.component.html',
  styleUrls: ['./contract-table.component.css']
})
export class ContractTableComponent implements OnInit {

  columns = [ 'contractnumber', 'contractdesc', 'contracttype', 'contractstate', 'controls' ];
  footerColumns = [ 'contractnumber' ];

  active: string = 'contactperslname';
  direction: SortDirection = 'asc';

  constructor(
    @Inject(CONTRACTS_PROVIDER_SERVICE) public providerService: IContractsProviderService,
    private _router: Router
  ) { }

  ngOnInit(): void {
    Contract
  }

  showContract = (contract: Contract) => this._router.navigate(['/contract-details', contract.contractid]);

  sortData(sort: Sort){
    this.active = sort.active;
    this.direction = sort.direction;
  }

}
